import { Button } from '../common/button'
import useTranslator from '@pma/hooks/use-translator'
import { Separator } from '../common/separator'
import { useRef, useState } from 'react'
import { Input } from '../common/input'
import { DictType } from '@pma/types'
import { HexColorPicker } from 'react-colorful'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../common/dropdown-menu'

type Props = {
  option: 'task' | 'project' | 'user'
  data: DictType
  setPriority: React.Dispatch<React.SetStateAction<DictType>>
}

const UpdatePriority = ({ option, data, setPriority }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const colorPickerRef = useRef<HTMLDivElement | null>(null)
  const { translate } = useTranslator()
  
  return (
    <div className='space-y-2'>
      <h4 className='font-semibold'>
        {translate('Update')} {translate(option)} {translate('priority')}
      </h4>
      <Separator />
      <div className='flex w-full flex-col gap-2'>
        <h3 className='text-xs font-semibold'>{translate('Name')}</h3>
        <Input
          placeholder={translate('Priority')}
          className='w-full'
          required
          value={data.name}
          onChange={(e: any) => setPriority((prev) => ({ ...prev, name: e.target.value }))}
          onFocus={() => setIsOpen(false)}
        />
        <h3 className='text-xs font-semibold'>{translate('Level')}</h3>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant='outline'
              size='sm'
              className='flex h-9 justify-start px-3 py-1 text-black'
            >
              <span>{data.level}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align='start'>
            {Array.from(Array(4).keys()).map((val) => {
              return (
                <DropdownMenuItem
                  onSelect={(e: any) =>
                    setPriority((prev) => ({ ...prev, level: e.target.textContent }))
                  }
                >
                  {val + 1}
                </DropdownMenuItem>
              )
            })}
          </DropdownMenuContent>
        </DropdownMenu>
        {option !== 'user' && (
          <>
            <h3 className='text-xs font-semibold'>{translate('Background Color')}</h3>
            <div className='relative'>
              <Button
                className='w-full'
                style={{
                  background: data.color,
                }}
                onClick={() => setIsOpen(!isOpen)}
              />
              {isOpen && (
                <div className='absolute' ref={colorPickerRef}>
                  <HexColorPicker
                    className=''
                    color={data.color}
                    onChange={(e: any) => setPriority((prev) => ({ ...prev, color: e }))}
                    onBlur={() => setIsOpen(false)}
                  />
                </div>
              )}
            </div>

            <Input
              type='text'
              pattern='^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
              placeholder='#0000ff'
              value={data.color}
              onChange={(e: any) => setPriority((prev) => ({ ...prev, color: e.target.value }))}
              onFocus={() => setIsOpen(false)}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default UpdatePriority
